import React                   from 'react'
import { connect }             from 'react-redux'
import i18n from '../../../i18n';
import { Modal, ModalBody, UncontrolledPopover, PopoverBody, Tooltip } from 'reactstrap';
import { withRouter } from "react-router-dom"
import ButtonLoading from "../../common/ButtonLoading"
import {DateHelper, SHORT_DATETIME_FORMAT} from '../../../util/date-helper'
import ToastHelper from '../../../util/toast-helper'
import Loading from '../../common/Loading'
import withBaseComponent from '../../withBaseComponent';
import {mapDispatchToProps} from "../../mapDispatchToProps"

class BankHeader extends withBaseComponent(React.Component) {
  constructor(props) {
    super(props);

    this.callInquire = this.callInquire.bind(this)
    this.callAccount = this.callAccount.bind(this)
    this.handleEditLogin = this.handleEditLogin.bind(this)
    this.toggleTooltip = this.toggleTooltip.bind(this)

    this.state = {
      isInquireProcessing: false,
      countRetryAccount: 0,
      countRetryInquire: 0,
      loadingIndentifier: false,
      tooltipOpen: false
    };

    this.constants = {
      MSG_TYPE: {
        TEXT: 0,
        SUPPORT_LINK: 1,
        POPOVER: 2,
        ADDITION_FORM: 3,
        AGGREGATED_DATE: 4
      },
      SECOND_MSG_TYPE: {
        TEXT: 0,
        MESSAGE_TEXT: 1,
        LINK_TO_SERVICE_LOGIN: 2,
        LINK_TO_EDIT_LOGIN: 3
      }
    }

    this.statusListObject = this.buildStatusListObject()
  }

  inquire(accountId) {
    this.setState({
      countRetryAccount: 0,
      countRetryInquire: 0,
      isInquireProcessing: true
    })

    this.callAccount(accountId)
  }

  callAccount(accountId) {
    const {status, error} = this.props.account

    if(this.state.countRetryAccount === 10) {
      this.endInquire()
      return ToastHelper.error(i18n.t("bank.messages.can_not_call_inquire"))
    }

    if (status.code === 1){
      this.setState({countRetryAccount: this.state.countRetryAccount + 1})
      this.props.accountActions.accountShow(accountId).then(() => {
        setTimeout(() => this.callAccount(accountId), 5000)
      })
    } else if(status.code === 2 && [7, 8, 11].includes(error.id)){
      this.callInquire(accountId)
    } else { // give up call inquire when account has other status & error
      this.endInquire()
    }
  }

  callInquire(accountId) {
    const {additional_credentials, status, error} = this.props.account
    if(additional_credentials && this.state.isInquireProcessing){
      this.props.toggleModal('answer')
      this.endInquire()
    } else if(this.state.countRetryInquire === 10){
      ToastHelper.error(i18n.t("bank.messages.can_not_call_inquire"))
      this.endInquire()
    } else if(status.code === 2 && [7, 8, 11].includes(error.id)){
      this.setState({countRetryInquire: this.state.countRetryInquire + 1})
      this.props.accountActions.accountInquire(accountId).then(() => {
        this.props.accountActions.accountShow(accountId).then(() => {
          this.setState({countRetryAccount: 0})
          setTimeout(() => this.callAccount(accountId), 5000)
        })
      })
    } else { // give up call inquire when account has other status & error
      this.endInquire()
    }
  }

  endInquire() {
    this.setState({ isInquireProcessing: false, loadingIndentifier: false })
  }

  handleEditLogin() {
    const {identifiable_code} = this.props.account
    const {id, requires_provider_auth} = this.props.account.service

    this.refs.targetPopover.click()
    if(requires_provider_auth) {
      this.props.accountActions.editLoginService(id, identifiable_code, this.props.userEmail)
    } else {
      this.props.toggleModal('editLogin')
    }
  }

  getElapsedDayMsg(date){
    let result = ''
    let diff = DateHelper.diffFromNow(date, 'minutes')

    if(diff < 60){
      result = i18n.t('bank.item_bank.status_messages.minutes_success', {value: diff})
    } else {
      diff = DateHelper.diffFromNow(date, 'hours')

      if(diff < 24){
        result = i18n.t('bank.item_bank.status_messages.hours_success', {value: diff})
      } else {
        diff = DateHelper.diffFromNow(date, 'days')
        result = i18n.t('bank.item_bank.status_messages.days_success', {value: diff})
      }
    }

    return result
  }

  // Refer to docs: https://docs.google.com/spreadsheets/d/1Kz5GlYKpAOKDPN35UZ3_VHhBkKfSdXFmtKLR4-ovGgk/edit#gid=0
  buildStatusListObject(){
    const {MSG_TYPE, SECOND_MSG_TYPE} = this.constants
    let result = {}

    result[this.buildKey(true, 0, 0, null)] = {
      element_type: MSG_TYPE.SUPPORT_LINK,
    }

    result[this.buildKey(false, 0, 0, null)] = {
      element_type: MSG_TYPE.TEXT,
      message: i18n.t('bank.item_bank.status_messages.no_is_mfsc')
    };

    result[this.buildKey(true, 0, 0, 'value')] = {
      element_type: MSG_TYPE.AGGREGATED_DATE
    }

    result[this.buildKey(false, 0, 0, 'value')] = {
      element_type: MSG_TYPE.AGGREGATED_DATE
    }

    result[this.buildKey('any', 1, 'any', 'any')] = {
      element_type: MSG_TYPE.TEXT,
      message: i18n.t('bank.item_bank.status_messages.acquired'),
      second_element_type: SECOND_MSG_TYPE.TEXT,
      second_message: i18n.t('bank.item_bank.status_messages.is_getting'),
      tooltip_message: i18n.t('bank.item_bank.status_messages.acquired')
    };

    [1, 3, 9, 10].forEach((errorId) => {
      result[this.buildKey('any', 0, errorId, 'any')] = {
        element_type: MSG_TYPE.POPOVER,
        message: i18n.t('bank.item_bank.status_messages.try_again'),
        second_element_type: SECOND_MSG_TYPE.MESSAGE_TEXT,
        second_message: i18n.t('bank.item_bank.status_messages.unvailable_now'),
        tooltip_message: i18n.t('bank.item_bank.status_messages.try_again')
      }
    })

    result[this.buildKey('any', 0, 2, 'any')] = {
      element_type: MSG_TYPE.POPOVER,
      message: i18n.t('bank.item_bank.status_messages.try_again'),
      second_element_type: SECOND_MSG_TYPE.MESSAGE_TEXT,
      second_message: i18n.t('bank.item_bank.status_messages.under_maintenance'),
      tooltip_message: i18n.t('bank.item_bank.status_messages.try_again')
    }

    result[this.buildKey('any', 0, 4, 'any')] = {
      element_type: MSG_TYPE.POPOVER,
      message: i18n.t('bank.item_bank.status_messages.need_to_confirm'),
      second_element_type: SECOND_MSG_TYPE.LINK_TO_SERVICE_LOGIN,
      second_message: i18n.t('bank.item_bank.status_messages.please_login'),
      tooltip_message: i18n.t('bank.item_bank.status_messages.need_to_confirm')
    }

    result[this.buildKey('any', 2, 5, 'any')] = {
      element_type: MSG_TYPE.POPOVER,
      message: i18n.t('bank.item_bank.status_messages.error_in_login'),
      second_element_type: SECOND_MSG_TYPE.LINK_TO_EDIT_LOGIN,
      second_message: i18n.t('bank.item_bank.status_messages.notice_error_in_login'),
      tooltip_message: i18n.t('bank.item_bank.status_messages.error_in_login')
    }

    result[this.buildKey('any', 2, 7, 'any')] = {
      element_type: MSG_TYPE.ADDITION_FORM,
      message: i18n.t('bank.item_bank.status_messages.additional_authentication'),
      tooltip_message: i18n.t('bank.item_bank.status_messages.additional_authentication')
    }

    result[this.buildKey('any', 2, 8, 'any')] = {
      element_type: MSG_TYPE.ADDITION_FORM,
      message: i18n.t('bank.item_bank.status_messages.additional_authentication'),
      tooltip_message: i18n.t('bank.item_bank.status_messages.additional_authentication')
    }

    result[this.buildKey('any', 2, 11, 'any')] = {
      element_type: MSG_TYPE.ADDITION_FORM,
      message: i18n.t('bank.item_bank.status_messages.additional_authentication'),
      tooltip_message: i18n.t('bank.item_bank.status_messages.additional_authentication')
    }

    return result
  }

  buildKey(isMfsc, statusCode, errorId, lastAggregatedAt){
    if(statusCode !== 0 || errorId !== 0) {
      isMfsc = 'any'
    }

    if(statusCode === 1) {
      errorId = 'any'
    }

    if(statusCode !== 0 || errorId !== 0){
      lastAggregatedAt = 'any'
    }

    if(lastAggregatedAt)
      lastAggregatedAt = 'value'

    return [isMfsc, statusCode, errorId, lastAggregatedAt].join('_')
  }

  renderSecondMessage(type, second_message) {
    const {SECOND_MSG_TYPE} = this.constants
    const {service, message} = this.props.account

    switch(type){
      case SECOND_MSG_TYPE.LINK_TO_SERVICE_LOGIN:
        return <div>
          {message || second_message} <br/>
          <a target="_blank" href={service.login_url} rel="noopener noreferrer">{i18n.t('bank.item_bank.status_messages.open_service_site')}</a>
        </div>
      case SECOND_MSG_TYPE.LINK_TO_EDIT_LOGIN:
        return <div>
          <div className="description">{message || second_message}</div>
          <span className="btn-link" rel="noopener noreferrer" onClick={this.handleEditLogin}>{i18n.t('bank.item_bank.status_messages.edit_login')}</span>
          <br/>
          <a target="_blank" href={service.login_url} rel="noopener noreferrer">{i18n.t('bank.item_bank.status_messages.open_service_site')}</a>
        </div>
      case SECOND_MSG_TYPE.MESSAGE_TEXT:
        return message || second_message
      default:
        return second_message
    }
  }

  renderStatusMessage(statusObj) {
    const {MSG_TYPE} = this.constants
    const {id, last_succeeded_at} = this.props.account
    const {isInquireProcessing} = this.state
    const {element_type, message, second_element_type, second_message} = statusObj
    let statusMsg = message

    switch(element_type){
      case MSG_TYPE.SUPPORT_LINK:
        return <span className="status">
            <span>{i18n.t('bank.item_bank.status_messages.has_is_mfsc_first')}</span>
            <a href='/support-electronic-certificate-usage' rel="noopener noreferrer">{i18n.t('bank.item_bank.status_messages.link_has_is_mfsc')}</a>
            <span>{i18n.t('bank.item_bank.status_messages.has_is_mfsc_last')}</span>
          </span>
      case MSG_TYPE.POPOVER:
        const secondStatusMsgEl = this.renderSecondMessage(second_element_type, second_message)

        return <span className="status btn-link">{this.renderPopover(statusMsg, secondStatusMsgEl)}</span>
      case MSG_TYPE.ADDITION_FORM:
        return <span className="status"><ButtonLoading className="btn-link" text={statusMsg} onClick={() => this.inquire(id)} isProcessing={isInquireProcessing} /></span>
      case MSG_TYPE.AGGREGATED_DATE:
        const accountMessage = this.props.account.message
        statusMsg = this.getElapsedDayMsg(last_succeeded_at)

        if(accountMessage){
          const targetId = `aggregated_date_${id}`

          return <span className="status">{statusMsg}(<button className="btn-link" id={targetId}>{this.renderPopover('ご確認事項があります', accountMessage, {target_id: targetId})}</button>)</span>
        } else {
          return <span className="status">{statusMsg}</span>
        }
      default:
        return <span className="status">{statusMsg}</span>
    }
  }

  getStatus() {
    const {MSG_TYPE} = this.constants
    const {service, error, status, is_suspended, last_succeeded_at} = this.props.account
    const key = this.buildKey(service.is_mfsc, status.code, error.id, last_succeeded_at)
    let statusObj = null

    if (this.props.isSyncing){
      statusObj = {
        element_type: MSG_TYPE.TEXT,
        message: i18n.t('bank.item_bank.updating')
      }
    } else if(is_suspended) {
      statusObj = {
        element_type: MSG_TYPE.TEXT,
        message: i18n.t('bank.item_bank.status_messages.data_acquisition_stopped'),
        tooltip_message: i18n.t('bank.item_bank.status_messages.is_suspended')
      }
    } else if(this.state.isInquireProcessing) {
      statusObj = {
        element_type: MSG_TYPE.ADDITION_FORM,
        message: i18n.t('bank.item_bank.status_messages.additional_authentication'),
        tooltip_message: i18n.t('bank.item_bank.status_messages.additional_authentication')
      }
    } else {
      statusObj = this.statusListObject[key]
    }

    if ((!is_suspended) && (status.code !== 1)) {
      if (service.is_mfsc) {
        statusObj['tooltip_message'] = i18n.t('bank.item_bank.status_messages.perform_data_acquisition')
      }
    }

    return <div>
        {this.renderStatusMessage(statusObj)}
        {!this.props.isEnableRefresh && statusObj.tooltip_message && this.renderTooltip(statusObj.tooltip_message)}
      </div>
  }

  getIcon() {
    let icon = 'fa-exclamation-circle'
    const {is_suspended, last_succeeded_at, error, status} = this.props.account

    if (this.props.isSyncing){
      icon = 'fa-spinner fa-spin'
    } else if (is_suspended) {
      icon = 'fa-clock'
    } else if(this.state.isInquireProcessing) {
      icon = 'fa-exclamation-circle'
    } else if(status.code === 1) {
      icon = 'fa-spinner fa-spin'
    } else if (status.code === 0 && error.id === 0 && last_succeeded_at) {
      icon = 'fa-check-circle'
    }

    return <i className={`fas ${icon}`}></i>
  }

  renderPopover(statusMsg, secondStatusMsgEl, opts={}) {
    const {id} = this.props.account
    let targetId = opts.target_id ? opts.target_id : `notice_status_${id}`

    return <span>
      <span id={targetId} ref="targetPopover">
        {statusMsg}
      </span>
      <UncontrolledPopover placement="top" target={targetId} trigger="legacy" delay={0}>
        <PopoverBody>
          {secondStatusMsgEl}
        </PopoverBody>
      </UncontrolledPopover>
    </span>
  }

  componentDidMount() {
    const {id, encrypted_id} = this.props.account
    const {account_identifier, type} = this.props.match.params

    if (account_identifier === `${this.props.encryptedUid}.${encrypted_id}`) {
      if(type){
        this.setState({loadingIndentifier: true})
        switch (type) {
          case "edit":
            this.props.toggleModal('editLogin')
            this.setState({loadingIndentifier: false})
            break
          case "additional_request":
            this.inquire(id)
            break;
          default:
        }
      }

      this.props.history.push('/bank')
    }
  }

  loadingIndentifier() {
    if(!this.state.loadingIndentifier)
      return null

    return <Modal isOpen={this.state.loadingIndentifier} centered={true}>
        <ModalBody>
          <Loading className="fa-7x loading" style={{marginTop: '0px'}}/>
        </ModalBody>
    </Modal>
  }

  toggleTooltip(event) {
    if(event.type === "mouseover"){
      setTimeout(() => {
        !this.props.tooltipMouseOut && this.setState({
          tooltipOpen: true
        })
      }, 300)
    } else {
      this.setState({
        tooltipOpen: false
      })
    }
  }

  renderTooltip(message) {
    const {id} = this.props.account
    return <Tooltip placement="top" isOpen={this.state.tooltipOpen} target={`notice_refresh_${id}`} toggle={this.toggleTooltip}>
      {message}
    </Tooltip>
  }

  render() {
    const {last_aggregated_at} = this.props.account

    return (
      <div className="item-header-info">
        <p className="date">
          { last_aggregated_at && `${DateHelper.output(last_aggregated_at, SHORT_DATETIME_FORMAT)} ${i18n.t('bank.update')}` }
        </p>
        {this.getIcon()}
        {this.getStatus()}
        {this.loadingIndentifier()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    encryptedUid: state.user.get('encrypted_uid'),
    userEmail: state.user.get('email'),
    lastAction: state.lastAction
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BankHeader))
